import { fbt } from 'fbtee'
import { useLocation } from 'react-router-dom'
import { UserRound } from 'lucide-react'
import { useTransitionNavigate } from '../../lib/viewTransition'
import { PageLayout } from '../../components/PageLayout'
import { ProfileHero } from '../../components/profile/ProfileHero'
import { Button } from '../../components/ui/button'

/** Someone's profile opened without a session: profiles need one to be read. */
export function GuestProfileGate() {
  const navigate = useTransitionNavigate()
  const location = useLocation()
  return (
    <PageLayout back>
      <ProfileHero
        avatar={
          <div className="flex size-24 items-center justify-center rounded-full bg-muted">
            <UserRound className="size-10 text-muted-foreground" />
          </div>
        }
        actions={
          <Button className="h-9 flex-1" onClick={() => navigate('/login', { state: { from: location } })}>
            <fbt desc="Log in button on the guest profile page">Log in</fbt>
          </Button>
        }
      >
        <p className="text-sm text-muted-foreground">
          {fbt(
            'Log in to see this profile and the festivals you have in common.',
            'Shown when a signed-out visitor opens someone else’s profile',
          )}
        </p>
      </ProfileHero>
    </PageLayout>
  )
}
